import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

type HavaDurumu = 'gunesli' | 'bulutlu' | 'yagmurlu' | 'karli' | 'firtinali';

const DURUM_HARITA: Record<HavaDurumu, { emoji: string; gradient: string }> = {
  gunesli:   { emoji: '\u2600\uFE0F', gradient: 'linear-gradient(135deg, #f6d365 0%, #fda085 100%)' },
  bulutlu:   { emoji: '\u26C5',       gradient: 'linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)' },
  yagmurlu:  { emoji: '\uD83C\uDF27\uFE0F', gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' },
  karli:     { emoji: '\u2744\uFE0F', gradient: 'linear-gradient(135deg, #e0eafc 0%, #cfdef3 100%)' },
  firtinali: { emoji: '\u26C8\uFE0F', gradient: 'linear-gradient(135deg, #4b6cb7 0%, #182848 100%)' },
};

@Component({
  selector: 'widget-hava-durumu',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="hava" [style.background]="bg()">
      <div class="ust">
        <span class="sehir">{{ sehir() }}</span>
        <span class="emoji">{{ info().emoji }}</span>
      </div>
      <div class="sicaklik">{{ sicaklik() }}°C</div>
      <div class="alt">
        <span>\uD83D\uDCA7 %{{ nem() }}</span>
        <span>\uD83D\uDCA8 {{ ruzgar() }} km/h</span>
      </div>
    </div>
  `,
  styles: [`
    :host { display: block; }
    .hava {
      padding: 10px 14px; border-radius: 10px;
      color: #fff; position: relative; overflow: hidden;
    }
    .ust {
      display: flex; justify-content: space-between; align-items: center;
    }
    .sehir {
      font-size: 0.82em; font-weight: 600; opacity: 0.95;
      text-shadow: 0 1px 2px rgba(0,0,0,0.2);
    }
    .emoji {
      font-size: 1.6em; animation: salla 2.5s ease-in-out infinite;
    }
    .sicaklik {
      font-size: 2em; font-weight: 700; line-height: 1.1; margin: 2px 0 4px;
      text-shadow: 0 1px 3px rgba(0,0,0,0.15);
    }
    .alt {
      display: flex; gap: 12px; font-size: 0.75em; opacity: 0.9;
    }
    @keyframes salla {
      0%, 100% { transform: rotate(0deg); }
      25%      { transform: rotate(8deg); }
      75%      { transform: rotate(-8deg); }
    }
  `],
})
export class HavaDurumuComponent {
  sicaklik = input(20);
  durum = input<HavaDurumu>('gunesli');
  sehir = input('\u0130stanbul');
  nem = input(50);
  ruzgar = input(10);

  info = computed(() => DURUM_HARITA[this.durum()] ?? DURUM_HARITA.gunesli);
  bg = computed(() => this.info().gradient);
}
